// extracted by mini-css-extract-plugin
export default {"PieChart":"PieChart_PieChart__FBczl"};